module.exports = __webpack_public_path__ + "img/mqttDTUgaishu2.94eaf2b9.png";